import { find, flow, sortBy } from 'lodash/fp';

import { isDraftId } from '../sanity-draft';

type SanitySlugDocument = {
  _id?: string | null;
  identifier?: { current?: string | null } | null;
};

const getSanityDocumentBySlug = <T extends SanitySlugDocument>(
  documents: readonly T[] | null | undefined,
  slug: string,
): Partial<T> =>
  flow(
    sortBy<T>((doc) => !isDraftId(doc._id)),
    find<T>((doc) => doc.identifier?.current === slug),
  )(documents ?? []) || {};

export default getSanityDocumentBySlug;
